var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-events__listing"},_vm._l((_vm.sortEvents(_vm.events)),function(event,index){return _c('CalendarEvent',{key:index,attrs:{"event":event},on:{"eventClicked":function($event){return _vm.$emit('eventClicked', event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }